import type { ReactNode } from 'react';

import { DrawerBody } from 'design-system';

type DashboardDrawerLayoutProps = {
  header?: ReactNode;
  subheader?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
};

export const DashboardDrawerLayout = ({
  header,
  subheader,
  children,
  footer
}: DashboardDrawerLayoutProps) => (
  <div className='flex h-full min-h-0 flex-col'>
    {header != null && <div className='shrink-0'>{header}</div>}
    {subheader != null && <div className='shrink-0 px-6 py-6'>{subheader}</div>}
    <DrawerBody className={subheader == null ? undefined : 'pt-0'}>{children}</DrawerBody>
    {footer != null && <div className='shrink-0'>{footer}</div>}
  </div>
);
